import { ChevronDown, Download, Filter, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { exportCsv, fileStamp } from '../lib/exportActions'
import type { Personel } from '../types'
import { calismaTuruLabelKey } from './statusTone'

export function PersonelExportMenu({ filtered, all }: { filtered: Personel[]; all: Personel[] }) {
  const { t } = useTranslation()

  const run = (rows: Personel[], suffix: string) =>
    exportCsv(
      `personel_${suffix}_${fileStamp()}.csv`,
      [
        t('hr.personel.fields.sicil'),
        t('hr.personel.columns.personel'),
        t('hr.personel.columns.departman'),
        t('hr.personel.columns.pozisyon'),
        t('hr.personel.columns.giris'),
        t('hr.personel.columns.tur'),
        t('hr.personel.columns.durum'),
        t('hr.personel.fields.yonetici'),
        'E-posta',
        'Telefon',
      ],
      rows.map((p) => [
        p.sicil,
        p.ad,
        p.departman,
        p.pozisyon,
        p.ise_giris,
        t(calismaTuruLabelKey(p.calisma_turu)),
        t(`hr.personel.durum.${p.durum}`),
        p.yonetici,
        p.email,
        p.telefon,
      ]),
    )

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="bg-card shadow-xs">
          <Download />
          {t('hr.personel.export')}
          <ChevronDown className="size-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-xl">
        <DropdownMenuLabel>{t('hr.personel.actions.exportHint')}</DropdownMenuLabel>
        <DropdownMenuItem disabled={filtered.length === 0} onSelect={() => run(filtered, 'filtre')}>
          <Filter />
          {t('hr.personel.actions.exportFiltered', { n: filtered.length })}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => run(all, 'tum')}>
          <Users />
          {t('hr.personel.actions.exportAll', { n: all.length })}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
